export function resolveChallengeWireViewer({ activeFitnessProfile, profiles }) {
	if (activeFitnessProfile?.id) {
		return {
			fitnessProfileId: activeFitnessProfile.id,
			isHouseholdSession: true
		};
	}

	const primaryProfile = (profiles || []).find((p) => p.is_primary);
	return {
		fitnessProfileId: primaryProfile?.id ?? null,
		isHouseholdSession: false
	};
}
